import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { stashPendingDiscountCode } from '../utils/rebookPromo';

/**
 * Stash ?rabatt= / ?discount= from any public route so checkout auto-applies the code.
 */
export function usePromoFromQuery(): void {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fromQuery = (searchParams.get('rabatt') || searchParams.get('discount') || '').trim();
    if (fromQuery) {
      stashPendingDiscountCode(fromQuery);
    }
  }, [searchParams]);
}
